import React, { useState, useEffect, useRef } from "react";
import helper from "services/helper";
import DialogCustom from "./DialogCustom";

function ModalAlert({ 
  open = false,
  title = '',
  subTitle = '',
  content = `มีบางอย่างผิดพลาด`,
  onClose = () => console.log('onClose')
}) {
  let btnText = "ปิด"

  return (
    <DialogCustom visible={open} style={{ width: '342px' }} onHide={() => onClose()} onClickOut = {() => onClose()}>
      <div className="modal-header">
        { title ? <h5 className="modal-title" id="staticBackdropLabel" dangerouslySetInnerHTML={{ __html: title }}></h5> : <></> }
      </div>
      <div className="modal-body">
        {subTitle != null && subTitle !== "" ? (
          React.isValidElement(subTitle) ? (
            <div className="mb-0">{subTitle}</div>
          ) : (
            <p className="mb-0">{subTitle}</p>
          )
        ) : null}
        {content != null && content !== "" ? (
          React.isValidElement(content) ? (
            <div className="mb-0">{content}</div>
          ) : (
            <p className="mb-0">{content}</p>
          )
        ) : null}
      </div>
      <div className="modal-footer">
        <button 
          type="button" 
          className="btn btn-primary" 
          onClick={() => onClose()}
        >Close</button>
      </div>
    </DialogCustom>
  )
}

export default ModalAlert;
